import { createReducer } from 'redux-act'
import { all } from 'redux-saga/effects'

import { translatedConfigSelector as configSelector } from '~/config'

import { Entity } from '~/utils/entity-utils'

import API from '~/api'
import i18n from '~/i18n'
const __ = i18n.t.bind(i18n);

const entityName = 'productVideo';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}

export const reducer = createReducer(entity.reducer, {});

export const AVAILABILITY_PAID = 'paid';
export const AVAILABILITY_FREE_FOR_EVERYONE = 'free_for_everyone';

export const availability = {
  AVAILABILITY_PAID,
  AVAILABILITY_FREE_FOR_EVERYONE
};


export const getAvailabilityChoices = () => ([
  {value: AVAILABILITY_PAID, label: __("Paid")},
  {value: AVAILABILITY_FREE_FOR_EVERYONE, label: __("Free for Everyone")},
]);


export default {
  actions,
  workers,
  saga,
  reducer
}
